const initialState = localStorage.getItem("wishlist") ? JSON.parse(localStorage.getItem("wishlist")) : [];

const wishlistReducer = (state = initialState, action) => {
    let { type, payload } = action;
    switch (type) {
        case "UPDATE_WISHLIST":
            const result = state.find((data) => data.unit == payload.unit && data.username == payload.username);
            if (result) {
                state = state.filter((fav) => fav.unit != payload.unit || fav.username != payload.username);
                localStorage.setItem("wishlist", JSON.stringify(state));
            } else {
                state.push(payload);
                localStorage.setItem("wishlist", JSON.stringify(state));
            }
            return state;
        case "LOAD_WISHLIST":
            localStorage.setItem("wishlist", JSON.stringify(payload));
            state = JSON.parse(localStorage.getItem("wishlist"));
            return state;
        default:
            return state;
    }
};

export default wishlistReducer;
